import { parseResponse } from "../../utils/parseResponse";
import { AllCitiesModel, CityInfo } from "../../types";
import { cityResponseKeys } from "../responseKeys/responseKeys";

export function parseCitiesResponse(cities: string[]): AllCitiesModel {
    return {
        allCities: cities.map((el) =>
            parseResponse<CityInfo>(el, cityResponseKeys, ['Id'])
        ),
    };
}